import {
  PT_MASTERCATEGORY,
  PT_PRODUCT_LIST,
} from "../../../../routes/stack/paths/pt-home";
import { Api_DrawAnalyticalPath } from "../../../../connection/api/api-Machine-Learning";
import { set_dto_Merchant } from "../../../../classes/dto-setters/dto-setter";
import { dto_common } from "../../../../classes/dto-common";
import { Font } from "../../../../util/config-fonts";
import React from "react";
import "../../../../styles/css/pg-home-merchant-card.css";

export default class FilterMerchantCard extends React.PureComponent {
  render() {
    let data = this.props.data;
    if (data.IL === "" || data.IL === "N/A") {
      data.IL = dto_common.DefaultImageUrl;
    }
    return (
      <div
        onClick={() => {
          this.MerchantClick(data);
        }}
        className="fadeInUp animated pgHomeMerchantCard"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <img
          src={data.IL}
          style={{ width: "100%", height: 180 }}
          alt="Error"
          onError={(e) => {
            e.currentTarget.src = dto_common.DefaultImageUrl;
          }}
        />
        <div
          style={{
            position: "absolute",
            left: 5,
            top: 20,
            backgroundColor: data.IO === true ? "green" : "red",
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 5,
            paddingRight: 15,
            fontSize: Font.SmallDescription,
            color: data.IO === true ? "white" : "black",
          }}
        >
          <p
            style={{
              color: "white",
              padding: 0,
              fontSize: Font.Description,
              margin: 10,
            }}
          >
            {data.MerchantPromoText}
          </p>
        </div>
        <div
          style={{
            position: "absolute",
            left: 5,
            top: 20,
            backgroundColor: data.IO === true ? "green" : "red",
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 5,
            paddingRight: 15,
            fontSize: Font.Description,
            color: data.IO === true ? "white" : "black",
          }}
        >
          <p
            style={{
              color: "white",
              padding: 0,
              fontSize: Font.SmallDescription,
              margin: 0,
            }}
          >
            {data.MS}
          </p>
        </div>
        {data.MerchantPromoText !== "" ? (
          <div
            style={{
              position: "absolute",
              left: 5,
              top: 30,
              backgroundColor: "#27ae60",
              paddingTop: 3,
              paddingBottom: 3,
              paddingLeft: 5,
              paddingRight: 15,
            }}
          >
            <p
              style={{
                color: "white",
                padding: 0,
                fontSize: Font.Description,
                margin: 10,
              }}
            >
              {data.MerchantPromoText}
            </p>
          </div>
        ) : null}

        <div
          style={{
            margin: 0,
            lineClamp: 2,
            WebkitLineClamp: 2,
            fontSize: Font.Heading,
          }}
        >
          {data.Merchant}
        </div>
        <div
          style={{
            margin: 0,
            lineClamp: 2,
            WebkitLineClamp: 2,
            fontSize: Font.SmallDescription,
          }}
        >
          {data.Add1}
        </div>
      </div>
    );
  }

  async MerchantClick(rs) {
    rs.CATID = 0;

    await Api_DrawAnalyticalPath(42, rs.MID);
    await set_dto_Merchant(rs);

    if (rs.MT.toUpperCase() === "GR" || rs.MT.toUpperCase() === "AF") {
      this.props.navigate(PT_MASTERCATEGORY);
    } else {
      this.props.navigate(
        PT_PRODUCT_LIST.replace(":navPage", "home-filter").replace(
          ":isSec",
          "false"
        )
      );
    }
  }
}
